
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/mailchimp",
      function () {
        return require("private-next-pages/destinations/mailchimp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/mailchimp"])
      });
    }
  